import SectionTitle from '../SectionTitle';
import { isStringNotEmpty } from '../../utils/objectUtils';

const Section = ({ title, description, breadcrumbs, children, ...otherProps }) => {
    return (
        <section {...otherProps}>
            {breadcrumbs}
            {(isStringNotEmpty(title) || isStringNotEmpty(description)) ? (<SectionTitle title={title} description={description} />) : null}
            {children}
        </section>
    );
};

export default Section;